module.exports = __webpack_public_path__ + "static/media/3.84ec8e12.svg";